module.exports = __webpack_public_path__ + "static/media/comment-edit.04d1e840.svg";